import { useTranslation } from 'react-i18next';

type Flight404InfoModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export default function Flight404InfoModal({ isOpen, onClose }: Flight404InfoModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div
      className="modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <section
        className="flight404-info-modal"
        role="dialog"
        aria-modal="true"
        aria-label={t('flight404.title')}
      >
        <div className="modal-header modal-header-close-only">
          <button className="modal-close-button" type="button" onClick={onClose} aria-label={t('flight404.close')}>
            ×
          </button>
        </div>

        <div className="bbt-info-content">
          <div className="flight404-info-identity">
            <img className="flight404-info-logo" src="/image/logo/flight404.png" alt="FLIGHT 404 logo" />
            <strong>{t('flight404.tokenName')}</strong>
          </div>
          <p className="flight404-info-description">{t('flight404.description')}</p>
          <p className="flight404-info-status">{t('flight404.status')}</p>
        </div>
      </section>
    </div>
  );
}
